/* global Math */

import React, { Component } from "react";
import addMinutes from "date-fns/add_minutes";
import subMinutes from "date-fns/sub_minutes";
import differenceInMinutes from "date-fns/difference_in_minutes";
import cx from "classnames";
//
import {
  formatTime,
  isMorning,
  formatDuration,
  formatWeekDay,
} from "../services/date";
import { roundNearest } from "../utils";
import { TimeButton } from "./TimeButton";
import { Col } from "./Col";

class TimePicker extends Component {
  increment(amount) {
    const { value, onChange } = this.props;
    onChange(addMinutes(value, amount));
  }

  decrement(amount) {
    const { value, onChange } = this.props;

    onChange(subMinutes(value, amount));
  }

  render() {
    const { error, value, timeZone, mined, maxed } = this.props;
    const title = formatWeekDay(value, timeZone);

    const now = new Date();
    const diff = roundNearest(differenceInMinutes(value, now), 15);

    return (
      <div className="tpicker">
        <div className="tpicker__title">{title}</div>

        <TimePickerValue value={value} timeZone={timeZone} />

        <p className="u-mb-large">
          {error ? (
            <small className="u-danger">{error}</small>
          ) : (
            <small className="u-muted">
              (approx. {formatDuration(diff)} from now)
            </small>
          )}
        </p>

        <Col.C>
          <div className="u-mb-small">
            <TimeButton
              decrementDisabled={mined}
              incrementDisabled={maxed}
              onDecrement={(amount) => this.decrement(amount)}
              onIncrement={(amount) => this.increment(amount)}
              value={15}
            />
          </div>
          <div className="u-mb-small">
            <TimeButton
              decrementDisabled={mined}
              incrementDisabled={maxed}
              onDecrement={(amount) => this.decrement(amount)}
              onIncrement={(amount) => this.increment(amount)}
              value={60}
            />
          </div>
          <div className="u-mb-small">
            <TimeButton
              decrementDisabled={mined}
              incrementDisabled={maxed}
              onDecrement={(amount) => this.decrement(amount)}
              onIncrement={(amount) => this.increment(amount)}
              value={60 * 4}
            />
          </div>
        </Col.C>
      </div>
    );
  }
}

export default TimePicker;

function TimePickerValue({ value, timeZone }) {
  const isAm = isMorning(value, timeZone);
  const isPm = !isAm;

  return (
    <div className="screen__value">
      <div className="tpicker__apm">
        <small className={cx({ active: isAm })}>AM</small>
        <small className={cx({ active: isPm })}>PM</small>
      </div>
      <div className="tpicker__hhmm">{formatTime(value, timeZone, false)}</div>
    </div>
  );
}
